<div id="{{id}}" class="progress_bar en" title="{{value}}" [ngStyle]="{'width' : 'calc(100% - '+reduceWidth+'px)'}">
  <span *ngIf="valueNum < 30" class="progress_val_num">
    {{value}}
  </span>
  <div id="{{idVal}}" class="progress_val" [ngStyle]="{'width':value+'%'}">
    <span *ngIf="valueNum > 30">
      {{value == '100.00' ? '&nbsp;' : value}}
    </span>
  </div>
</div>
